<template>
<div class="OrderManage">
    <EventInfo :eventInfoData="eventInfoData"></EventInfo>
    <div class="order_manage_content_container spackage bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
            <el-tab-pane :label="'全部 ('+activeNum.totalCount+')'" name="first">
                <OrderTable @findStatisticalUserNum="findStatisticalUserNum" :eventInfoData="eventInfoData" :activeStatus="activeStatus" :eventListData="eventListData"></OrderTable>
            </el-tab-pane>
            <!-- <el-tab-pane :disabled="!false" :label="'待审核 ('+activeNum.audited+')'" name="second"> -->
            <el-tab-pane :label="'待审核 ('+activeNum.audited+')'" name="second">
                <OrderCheckTable @findStatisticalUserNum="findStatisticalUserNum" :eventInfoData="eventInfoData" :activeStatus="activeStatus" :eventListData="eventListData"></OrderCheckTable>
            </el-tab-pane>
            <el-tab-pane :label="'待支付 ('+activeNum.paying+')'" name="third">
                <OrderTable @findStatisticalUserNum="findStatisticalUserNum" :eventInfoData="eventInfoData" :activeStatus="activeStatus" :eventListData="eventListData"></OrderTable>
            </el-tab-pane>
            <el-tab-pane :label="'报名成功 ('+activeNum.success+')'" name="fourth">
                <OrderTable  @findStatisticalUserNum="findStatisticalUserNum" :eventInfoData="eventInfoData" :activeStatus="activeStatus" :eventListData="eventListData"></OrderTable>
            </el-tab-pane>
            <el-tab-pane :label="'已取消 ('+activeNum.cancelled+')'" name="fifth">
                <OrderTable @findStatisticalUserNum="findStatisticalUserNum" :eventInfoData="eventInfoData" :activeStatus="activeStatus" :eventListData="eventListData"></OrderTable>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import EventInfo from 'views/activeOperate/components/EventInfo'
import OrderTable from 'views/activeOperate/components/OrderTable'
import OrderCheckTable from 'views/activeOperate/components/OrderCheckTable'
import {statisticalOrders, eventInfo, getEenrolleventOrderList} from 'api/activeApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'OrderManage',
    data() {
        return {
            eventInfoData: {},
            activeName: 'first',
            activeName2: 'first',
            activeStatus: 0,
            activeNum: {
                audited: 0,
                cancelled: 0,
                paying: 0,
                success: 0,
                totalCount: 0
            },
            eventListData: {
                content: [],
                pageinfo: {
                    rowCount: 0
                }
            }
        }
    },
    mounted() {
        this.findSimpleEventDetail()
        this.findStatisticalUserNum()
        this.findOrderList(this.activeStatus)
    },
    methods: {
        handleClick(tabName) {
            if (tabName === this.activeName2) {
                // 点击同一个tab不做处理
            } else {
                this.activeName2 = tabName
                if (tabName === 'first') {
                    // 全部
                    this.activeStatus = 0
                } else if (tabName === 'second') {
                    // 待审核（40）
                    this.activeStatus = 1
                } else if (tabName === 'third') {
                    // 待支付（10）
                    this.activeStatus = 9
                } else if (tabName === 'fourth') {
                    // 报名成功（140）
                    this.activeStatus = 30
                } else if (tabName === 'fifth') {
                    // 已取消（20）
                    this.activeStatus = 100
                }
                // this.findStatisticalUserNum()
                this.findOrderList(this.activeStatus)
            }
        },
        // 查询活动基本简略信息
        findSimpleEventDetail() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            eventInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventInfoData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 统计名单的各个状态的数量
        findStatisticalUserNum() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            statisticalOrders({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.activeNum = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 查询名单信息列表
        findOrderList(val) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: val,
                page: 1,
                pageSize: 10
            }
            getEenrolleventOrderList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        EventInfo,
        OrderTable,
        OrderCheckTable
    }
}
</script>

<style lang="scss" type="text/scss">
.OrderManage {
    font-family:PingFangSC-Regular,PingFang SC;
    .order_manage_content_container {
        margin-top: 24px;
        .el-tabs__item {
            padding: 0 20px!important;
        }
        .el-tabs__header {
            margin: 0 0 24px;
        }
    }
    .cancellation_order_pop_box, .approval_pop_box {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
            z-index: 2998!important;
        }
        .el-dialog {
            z-index: 2999!important;
            margin: 0!important;
            width: 578px;
        }
        .tips_content_box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: PingFangSC-Regular,PingFang SC;
            &>img{
                width: 44px;
                height: 44px;
            }
            &>p{
                margin: 10px 0;
                line-height:24px;
                font-size:16px;
                color: #F56C6C;
            }
            .p_tips1 {
                margin-bottom: 40px;
            }
            .p_tips2 {
                color: #666;
                font-size:14px;
                line-height:20px;
                margin-top: 0px;
                margin-bottom: 40px;
            }
            .cancellation_content_box, .approval_content_box{
                width: 500px;
                &>p{
                    line-height:28px;
                    font-size:14px;
                    color: #666666;
                    &>span:nth-of-type(1){
                        display: inline-block;
                        width: 50%;
                    }
                }
            }
        }
    }
    .right_details_box{
        position: fixed;
        top: 50px;
        right: -398px;
        height: 95.5vh;
        width: 398px;
        z-index: 10;
        box-sizing: border-box;
        box-shadow:-2px 0px 6px 0px rgba(0,0,0,0.1);
        font-family:PingFangSC-Regular,PingFang SC;
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 46%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 52px;
            box-shadow: -2px 0px 6px 0px rgba(0,0,0,0.1);
            span{
                font-weight: bold;
                font-size: 15px;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .details_info_box {
            .box1 {
                display: flex;
                align-items: center;
                padding: 30px 20px 40px 20px;
                img {
                    width: 64px;
                    height: 64px;
                    border-radius: 100%;
                    margin-right: 28px;
                }
                div {
                    p{
                        color:#999999;
                        line-height:20px;
                    }
                    p:nth-of-type(1){
                        color: #333333;
                    }
                    p:nth-of-type(2){
                        margin-top: 8px;
                        margin-bottom: 4px;
                    }
                }
            }
            .box2 {
                padding: 0 20px;
                height: 75vh;
                overflow-y: auto;
                p{
                    display: flex;
                    line-height:20px;
                    color: #333333;
                    margin-top: 20px;
                    span:nth-of-type(1){
                        line-height:20px;
                        color:#999999;
                        width: 120px;
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    span:nth-of-type(2){
                        line-height:20px;
                    }
                }
                &>div{
                    border-top: solid 1px #E5E5E5;
                    padding-bottom: 20px;
                }
                &>div:last-of-type {
                    padding-bottom: 100px;
                }
                .ptitle {
                    margin-top: 0px;
                    padding: 8px 0;
                    font-weight: bold;
                    font-size: 15px;
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 0.5s all;
    }
    .hide_icon_box{
        right: -398px;
        transition: 0.5s all;
    }
}
</style>